import { BillOfMaterialService } from './../../services/BillOfMaterial.service';
import {
  ModuleStructure,
} from './../module-structure';
import {
  RecordLine,
  RecordModel,
  RecordCategory,
} from './../../layout/record-model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from 'src/app/layout/layout.service';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';

export class ProductionOrders {
  maxLineNum = 0;

  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService,
    private billOfMaterialService: BillOfMaterialService
  ) {
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      try {
        if (args.recordModel.ObjectKey !== 'oProductionOrders') {
          return;
        }
        this.oProductionOrders(args);
      } catch (e) {
        console.error(
          'An error occured while trying to execute ProductionOrders',
          args,
          e
        );
      }
    });

    layoutService.objectLoadChanged.subscribe(
      (args: {
        recordModel: RecordModel;
        moduleStructure: ModuleStructure;
      }) => {
        try {
          if (args.recordModel.ObjectKey !== 'oProductionOrders') {
            return;
          }

          // this.ObjectLoad(args.recordModel, args.moduleStructure);
        } catch (e) {
          console.log('error during loading the object, the error is:', e);
        }
      }
    );
  }

  oProductionOrders(args: FieldValueChangedArgs) {
    const headerCategory = args.recordModel.Categories.find(
      (x) => x.Id === 'ProductionOrders'
    );

    const linesCategory = args.recordModel.Categories.find(
      (x) => x.Id === 'ProductionOrders_Lines'
    );

    if (args.sectionTagName === 'ProductionOrders_Lines') {
      if (args.recordProperty.Name === 'ItemType') {
        // modify the view according to type
        const itemType = linesCategory.Lines[args.line].Properties.find(
          (prop) => prop.Name === 'ItemType'
        ).ValueAsObject;
        if (itemType === 'pit_Text') {
          linesCategory.Lines[args.line].Properties.forEach((element) => {
            if (element.Name !== 'ItemType') {
              element.Visible = false;
            }
          });
          linesCategory.Lines[args.line].Properties.find(
            (prop) => prop.Name === 'LineText'
          ).Visible = true;
        } else {
          linesCategory.Lines[args.line].Properties.find(
            (prop) => prop.Name === 'LineText'
          ).Visible = false;
          linesCategory.Lines[args.line].Properties.forEach((element) => {
            if (element.Name !== 'LineText') {
              element.Visible = true;
            }
          });
        }
      } else if (args.recordProperty.Name === 'BaseQuantity') {
        const planned = Number(
          headerCategory.Lines[0].Properties.find(
            (prop) => prop.Name === 'PlannedQuantity'
          ).ValueAsObject
        );

        const baseQty = Number(
          linesCategory.Lines[args.line].Properties.find(
            (prop) => prop.Name === 'BaseQuantity'
          ).ValueAsObject
        );

        linesCategory.Lines[args.line].Properties.find(
          (prop) => prop.Name === 'PlannedQuantity'
        ).ValueAsObject = baseQty * planned;
      } else if (args.recordProperty.Name === 'PlannedQuantity') {
        const planned = Number(
          headerCategory.Lines[0].Properties.find(
            (prop) => prop.Name === 'PlannedQuantity'
          ).ValueAsObject
        );

        const plannedQty = Number(
          linesCategory.Lines[args.line].Properties.find(
            (prop) => prop.Name === 'PlannedQuantity'
          ).ValueAsObject
        );

        linesCategory.Lines[args.line].Properties.find(
          (prop) => prop.Name === 'BaseQuantity'
        ).ValueAsObject = plannedQty / planned;
      } else if (args.recordProperty.Name === 'ItemNo') {
        const planned = Number(
          headerCategory.Lines[0].Properties.find(
            (prop) => prop.Name === 'PlannedQuantity'
          ).ValueAsObject
        );

        const baseQty = Number(
          linesCategory.Lines[args.line].Properties.find(
            (prop) => prop.Name === 'BaseQuantity'
          ).ValueAsObject
        );

        linesCategory.Lines[args.line].Properties.find(
          (prop) => prop.Name === 'PlannedQuantity'
        ).ValueAsObject = baseQty * planned;
      }
    } else if (args.sectionTagName === 'ProductionOrders') {
      let field = headerCategory.Lines[args.line].Properties.find(
        (prop) => prop.Name === args.recordProperty.Name
      );

      if (field != null || field !== undefined) {
        field = args.recordProperty;
      }

      if (
        args.recordProperty.Name === 'ItemNo' ||
        args.recordProperty.Name === 'ProductionOrderType'
      ) {
        this.maxLineNum = 0;

        const parentItemCode = headerCategory.Lines[0].Properties.find(
          (prop) => prop.Name === 'ItemNo'
        ).ValueAsObject;

        this.removeAllLines(args.recordModel);
        this.addBOMLines(args, parentItemCode);
      } else if (args.recordProperty.Name === 'PlannedQuantity') {
        const planned = Number(
          headerCategory.Lines[0].Properties.find(
            (prop) => prop.Name === 'PlannedQuantity'
          ).ValueAsObject
        );

        linesCategory.Lines.forEach((element) => {
          const baseQty = Number(
            element.Properties.find((prop) => prop.Name === 'BaseQuantity')
              .ValueAsObject
          );

          element.Properties.find(
            (prop) => prop.Name === 'PlannedQuantity'
          ).ValueAsObject = baseQty * planned;
        });
      }
    }
  }

  removeAllLines(recordModel: RecordModel) {
    const linesCat = recordModel.Categories.find(
      (cat) => cat.Id === 'ProductionOrders_Lines'
    );
    linesCat.Lines = [];
    linesCat.MaxIndex = 0;
    linesCat.LineToDelete = '';
    linesCat.DeletedLines = [];
  }

  addBOMLines(args: FieldValueChangedArgs, parentItemCode: string) {
    const headerSection = args.recordModel.Categories.find(
      (x) => x.Id === 'ProductionOrders'
    );

    this.layoutService
      .executeQuery(2556, { 'ProductionOrders.ItemNo': parentItemCode })
      .subscribe((result: any[]) => {
        console.log(result);
        let mainPlannedQty = 0;
        if (result.length > 0) {
          mainPlannedQty = Number(result[0].Qauntity);

          const fieldToUpdate = headerSection.Lines[0].Properties.find(
            (prop) => prop.Name === 'PlannedQuantity'
          );

          LayoutService.setValue(
            fieldToUpdate,
            mainPlannedQty,
            this.layoutService,
            args.recordModel,
            0,
            'ProductionOrders',
            args.moduleStructure
          );
        }

        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < result.length; i++) {
          this.addLineToTable(args, result[i], mainPlannedQty);
        }
      });
  }

  addLineToTable(args: FieldValueChangedArgs, data: any, baseQuantity: number) {
    let recordCategory: RecordCategory = null;
    const section = args.moduleStructure.module.Sections.find(
      (sec) => sec.XmlTagName === 'ProductionOrders_Lines'
    );
    args.recordModel.Categories.forEach((category) => {
      if (category.Id === section.XmlTagName) {
        recordCategory = category;
        return;
      }
    });

    if (recordCategory == null) {
      recordCategory = {
        Id: section.XmlTagName,
        Lines: [],
        DeletedLines: [],
      };
      args.recordModel.Categories.push(recordCategory);
    }
    if (recordCategory.Lines.length !== 0 && this.maxLineNum === 0) {
      this.maxLineNum =
        Math.max.apply(
          Math,
          recordCategory.Lines.map(
            (o) =>
              o.Properties.find((prop) => prop.Name === 'LineNumber')
                .ValueAsObject
          )
        ) + 1;
    } else {
      this.maxLineNum++;
    }

    let recordLine: RecordLine = null;
    recordLine = {
      Id: recordCategory.Lines.length,
      MaxIndex: this.maxLineNum,
      Properties: [],
    };

    console.log(recordLine);

    RecordModel.refineTheRecordModelLine(this.layoutService,section, recordLine, []);

    recordCategory.Lines = [...recordCategory.Lines, recordLine];
    recordCategory.MaxIndex = this.maxLineNum;

    recordLine.IsNew = true;

    /*for (const property of recordLine.Properties) {
      const field = section.Fields.find(
        (p) => p.PropertyName === property.Name
      );
      if (field.DataType === FieldDataType.Select) {
        RecordModel.getOptions(
          field,
          args.recordModel,
          property,
          args.sectionTagName,
          recordLine.Id,
          recordCategory,
          this.layoutService,
          args.moduleStructure
        );
      }
    }*/
    const itemNo = recordLine.Properties.find((p) => p.Name === 'ItemNo');
    // recordLine.Properties.find((p) => p.Name === 'ItemNo').ValueAsObject =
    //   data.Code;
    LayoutService.setValue(
      itemNo,
      data.Code,
      this.layoutService,
      args.recordModel,
      args.line,
      'ProductionOrders_Lines',
      args.moduleStructure
    );
    // recordLine.Properties.find(
    //   (p) => p.Name === 'PlannedQuantity'
    // ).ValueAsObject = data.Quantity;
    LayoutService.setValue(
      recordLine.Properties.find((p) => p.Name === 'PlannedQuantity'),
      data.Quantity,
      this.layoutService,
      args.recordModel,
      args.line,
      'ProductionOrders_Lines',
      args.moduleStructure
    );
    recordLine.Properties.find((p) => p.Name === 'ItemName').ValueAsObject =
      data.ItemName;

    recordLine.Properties.find((p) => p.Name === 'LineText').ValueAsObject =
      data.LineText;

    // item type  Type
    let itemType = data.Type;
    // [pit_Item:4:Item;pit_Resource:290:Resource;pit_Text:-18:Text]
    if (itemType === '4' || itemType === 4) {
      itemType = 'pit_Item';
    } else if (itemType === '290' || itemType === 290) {
      itemType = 'pit_Resource';
    } else if (itemType === '-18' || itemType === -18) {
      itemType = 'pit_Text';
    }

    recordLine.Properties.find((p) => p.Name === 'ItemType').ValueAsObject =
      itemType;

    // recordLine.Properties.find((p) => p.Name === 'Warehouse').ValueAsObject =
    //   data.Warehouse;
    LayoutService.setValue(
      recordLine.Properties.find((p) => p.Name === 'Warehouse'),
      data.Warehouse,
      this.layoutService,
      args.recordModel,
      args.line,
      'ProductionOrders_Lines',
      args.moduleStructure
    );
    // issue type  IssueMthd  ProductionOrderIssueType
    let issueMethod = data.IssueMthd;
    // [im_Backflush:B:Backflush;im_Manual:M:Manual]
    if (issueMethod === 'B') {
      issueMethod = 'im_Backflush';
    } else if (issueMethod === 'M') {
      issueMethod = 'im_Manual';
    }

    // recordLine.Properties.find(
    //   (p) => p.Name === 'ProductionOrderIssueType'
    // ).ValueAsObject = issueMethod;
    const prodOrderIssueType = recordLine.Properties.find(
      (p) => p.Name === 'ProductionOrderIssueType'
    );
    LayoutService.setValue(
      prodOrderIssueType,
      issueMethod,
      this.layoutService,
      args.recordModel,
      args.line,
      'ProductionOrders_Lines',
      args.moduleStructure
    );
    // recordLine.Properties.find((p) => p.Name === 'BaseQuantity').ValueAsObject =
    //   data.Quantity / baseQuantity;
    LayoutService.setValue(
      recordLine.Properties.find((p) => p.Name === 'BaseQuantity'),
      data.Quantity / baseQuantity,
      this.layoutService,
      args.recordModel,
      args.line,
      'ProductionOrders_Lines',
      args.moduleStructure
    );
  }
}
